import { ActionIcon, Box } from '@cowbell/ui/core';
import { useCallback } from 'react';
import Draggable from 'react-draggable';
import { useDispatch, useSelector } from 'react-redux';
import MooAgent from '../../../../_assets/svg/agents/MooAgent.svg';
import { setAskMooFabPosition } from '../../../../reducers/UiSettingsReducers';
import { selectAskMooFabPosition } from '../../../../store/selectors/ui-settings.selectors';
import AgentAvatar from '../../components/AgentAvatar';
import { useFabDraggable } from '../../hooks/useFabDraggable';
import type { Agent } from '../../types';

import classes from './MooChatFloatingIcon.module.css';

export function MooChatFloatingIcon({
  selectedAgent,
  toggleLauncher,
}: {
  selectedAgent: Agent | null;
  toggleLauncher: () => void;
}) {
  const dispatch = useDispatch();
  const persistedFabPosition = useSelector(selectAskMooFabPosition);
  const persistFabPosition = useCallback(
    (pos: { x: number; y: number }) => dispatch(setAskMooFabPosition(pos)),
    [dispatch]
  );

  const {
    position: fabPos,
    bounds: fabDragBounds,
    nodeRef: fabNodeRef,
    draggableHandlers: fabDraggableHandlers,
    draggedRef: fabDraggedRef,
  } = useFabDraggable({
    persisted: persistedFabPosition,
    onPersist: persistFabPosition,
  });

  function handleActionIconClick() {
    if (fabDraggedRef.current) {
      fabDraggedRef.current = false;
      return;
    }
    toggleLauncher();
  }

  return (
    <Draggable
      nodeRef={fabNodeRef}
      position={fabPos}
      bounds={fabDragBounds}
      onStart={fabDraggableHandlers.onStart}
      onDrag={fabDraggableHandlers.onDrag}
      onStop={fabDraggableHandlers.onStop}
    >
      <Box ref={fabNodeRef} className={classes.wrapper}>
        <ActionIcon
          variant="transparent"
          size={48}
          onClick={handleActionIconClick}
          radius="xl"
        >
          {selectedAgent ? (
            <AgentAvatar agent={selectedAgent} size="md" />
          ) : (
            <MooAgent width={48} height={48} />
          )}
        </ActionIcon>
      </Box>
    </Draggable>
  );
}
